import Dexie, { _Table, EntityTable } from "dexie";

// export type DocumentSyncStatus = "in_sync" | "queued" | "sync_error" | "not_synced";

export type Document = {
  id: number;
  key: string;

  etag: string;
  size: number;
  last_modified: number;
  deleted?: boolean;
  seq: number;

  title?: string;

  // Local data
  stored_etag?: string;
  download_order?: number | undefined;
  downloaded_at?: number;
};

interface SyncMeta {
  key: string;
  val: number;
}

export type DocRefs = Record<number, number>;

export type DCMSDocumentDB = Dexie & {
  syncmeta: EntityTable<SyncMeta, "key">;
  documents: EntityTable<Document, "id">;
  files: _Table<Uint8Array | Blob, string, Uint8Array>;
};

export const db = new Dexie("documents") as DCMSDocumentDB;

export interface TokenRecord {
  token: string;
  ver: number;
  scores: Record<string, number>;
}

db.version(23).stores({
  syncmeta: "key",
  documents: "id,key,download_order,seq,downloaded_at,last_modified,modified,title",
  // Stores files as Uint8Arrays or Blobs (files will only be written as Uint8Arrays from now on)
  files: "",
});

export async function recreateDatabase() {
  window.localStorage.removeItem("lastSyncDate");
  await db.delete();
  await db.open();
}

export function getDocumentTitle(doc: Document, titleField: string) {
  let title = (doc as any)[titleField];
  const lastDot = doc.key.lastIndexOf(".");

  if (!title) {
    // No title metadata - use the document name instead.
    title = doc.key.substring(doc.key.startsWith("docs/") ? 5 : 0, lastDot === -1 ? doc.key.length : lastDot);
  }
  const ext = lastDot === -1 ? "unknown" : doc.key.substring(lastDot + 1).toLowerCase();
  return [title, ext];
}

export async function unmarshallFile(val: Blob | Uint8Array | undefined): Promise<Uint8Array | undefined> {
  if (!val) {
    return undefined;
  }
  if (val instanceof Blob) {
    val = new Uint8Array(await val.arrayBuffer());
  }
  return val;
}
